module.exports = __webpack_public_path__ + "img/flag_fr.ea9ea05c.png";